import { Star, Quote } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { TESTIMONIALS } from "../data/content";

export const Testimonials = () => (
  <section className="bg-background py-24 sm:py-32" data-testid="testimonials-section">
    <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-end gap-6 mb-16">
        <div className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.25em] text-blue-700 mb-5">Kundenstimmen</p>
          <h2 className="text-4xl sm:text-5xl font-heading font-semibold tracking-tight text-navy-900 leading-[1.05]">
            Was unsere Kunden <span className="font-serif italic text-blue-700">wirklich</span> sagen.
          </h2>
        </div>
        <div className="flex items-center gap-2">
          {[...Array(5)].map((_, i) => <Star key={i} className="h-5 w-5 fill-blue-600 text-blue-600" />)}
          <span className="text-sm text-slate-500 ml-2">4,9 / 5 · deutschlandweit</span>
        </div>
      </div>

      <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={i} delay={(i % 3) * 0.08}>
            <div className="break-inside-avoid rounded-3xl border border-slate-200 bg-white p-8 hover:shadow-[0_30px_60px_-35px_rgba(0,0,0,0.2)] hover:-translate-y-1 transition-[transform,box-shadow] duration-500" data-testid={`testimonial-${i}`}>
              <Quote className="h-8 w-8 text-blue-600/30 mb-4" />
              <p className="text-navy-900 leading-relaxed text-lg font-light">„{t.text}"</p>
              <div className="mt-6 flex items-center gap-3">
                <span className="h-10 w-10 rounded-full bg-navy-950 text-white grid place-items-center font-heading text-sm">
                  {t.name.charAt(0)}
                </span>
                <div>
                  <p className="font-medium text-navy-900 text-sm">{t.name}</p>
                  <p className="text-xs text-slate-400">{t.city}</p>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
